import { render, staticRenderFns } from "./connection.vue?vue&type=template&id=1036abe5&scoped=true&"
import script from "./connection.vue?vue&type=script&lang=js&"
export * from "./connection.vue?vue&type=script&lang=js&"
import style0 from "./connection.vue?vue&type=style&index=0&id=1036abe5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1036abe5",
  null
  
)

export default component.exports